export default {
  setLocale: 'USER_ACTIONS_SET_LOCALE',
  tryAutoSignIn: 'USER_ACTIONS_TRY_AUTO_SIGNIN',
  signIn: 'USER_ACTIONS_SIGNIN',
  register: 'USER_ACTIONS_REGISTER',
  signInWithFacebook: 'USER_ACTIONS_SIGNIN_WITH_FACEBOOK',
  signInWithApple: 'USER_ACTIONS_SIGNIN_WITH_APPLE',
  callback: 'USER_ACTIONS_HANDLEAUTHCALLBACK',
  signOut: 'USER_ACTIONS_SIGNOUT',
  confirmSignIn: 'USER_ACTIONS_CONFIRM_SIGNIN',
  loadUser: 'USER_ACTIONS_LOAD',
  saveUser: 'USER_ACTIONS_SAVE'
}
